// Tryb offline (spec/pwa.md → Etap 2: offline read) — czysta logika bez DOM, testowana w tests/unit/offline_core_test.ts.

export interface DataSourceDetail {
  /** true = odpowiedź podana przez service worker z cache (brak sieci). */
  fromCache: boolean;
  /** ISO czas zapisania kopii (nagłówek X-Cached-At), null gdy nieznany. */
  cachedAt: string | null;
}

/** Odczyt informacji o źródle danych z nagłówków odpowiedzi (ustawianych przez sw.js). */
export function dataSourceFromHeaders(headers: { get: (name: string) => string | null }): DataSourceDetail {
  return {
    fromCache: headers.get('X-From-Cache') === '1',
    cachedAt: headers.get('X-Cached-At'),
  };
}

/** „sprzed chwili” / „sprzed 5 min” / „sprzed 3 godz.” / „z wczoraj” / „sprzed 4 dni”. */
export function formatCacheAge(cachedAt: string | null, now: number): string {
  if (!cachedAt) return 'z nieznanego czasu';
  const t = Date.parse(cachedAt);
  if (Number.isNaN(t)) return 'z nieznanego czasu';
  const minutes = Math.max(0, Math.round((now - t) / 60000));
  if (minutes < 1) return 'sprzed chwili';
  if (minutes < 60) return `sprzed ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `sprzed ${hours} godz.`;
  const days = Math.floor(hours / 24);
  return days === 1 ? 'z wczoraj' : `sprzed ${days} dni`;
}

/** Treść paska offline. */
export function offlineBannerText(detail: DataSourceDetail, now: number): string {
  return `Brak połączenia. Pokazuję dane z pamięci ${formatCacheAge(detail.cachedAt, now)}. ` +
    'Zmiany nie zapiszą się, dopóki sieć nie wróci.';
}
